import { render, staticRenderFns } from "./ArchivedNotifications.vue?vue&type=template&id=d282e428&"
import script from "./ArchivedNotifications.vue?vue&type=script&lang=js&"
export * from "./ArchivedNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports